<template>
  <div class="sv sv010">
    <div class="container">
      <BreadcrumbGroup :items="breadcrumbItems" />

      <ContentsHeader class="-green" src="sv010/main.jpg">
        <p class="heading1">いまさら聞けない！ローンの基礎知識</p>
        <h1 class="heading2">ローンの返済方法や<br />ルールとは？</h1>
      </ContentsHeader>
    </div>

    <div class="container">
      <ContentsIntro
        class="-green _pt-sm-50"
        icon-left="sv010/avatar-a.gif"
        name-left="Aさん"
        icon-right="sv010/avatar-b.gif"
        name-right="Bさん"
        txt-relation="同僚の2人"
      >
        会社の同期であり、よき相談相手でもあるAさんとBさん。<br />
        Bさんは「お金を借りたいんだけど、取り立てが不安…」とAさんに悩みを打ち明けます。
      </ContentsIntro>
    </div>

    <hr class="-pcnone _mb-sm-60" />

    <div class="container">
      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >ローンの利用者は法律で守られているから安心！</HeadingTwo
      >

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv010/avatar-b.gif"
          >お金を借りてみようかと思ってるんだけど、もし返済ができなくて厳しい取り立てがあったらどうしよう…</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >ドラマの見すぎよ。電話でしつこく催促されたり、職場や家まで集金に来たりするのは、貸金業法という法律で禁止されているのよ</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-green _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-green" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -green">
            こんな取り立て行為は<br class="-pcnone" />法律で禁止されている！
          </h3>
        </div>
        <div class="card-body01">
          <div class="card-groups">
            <div class="card-box">
              <ListGroup class="-normal">
                <ListItem class="-normal"
                  >ローン利用者の承諾があるなど正当な理由がないのに勤務先など自宅以外の場所に訪問したり、電話やFAX送信したりすること</ListItem
                >
                <ListItem class="-normal"
                  >債務者の承諾があるなど正当な理由がないのに早朝や夜中（午後9時から午前8時）に訪問したり、電話やFAX送信したりすること</ListItem
                >
                <ListItem class="-normal"
                  >しつこく何度も訪問したり、「帰ってほしい」と言われたのに帰らないこと</ListItem
                >
                <ListItem class="-normal"
                  >玄関先に張り紙などをして、お金を借りたことをまわりに知らせること</ListItem
                >
                <ListItem class="-normal"
                  >クレジットカードや他の金融業者を利用して返済するように要求すること</ListItem
                >
                <ListItem class="-normal"
                  >友人や家族などからお金を借りて返済するように要求すること</ListItem
                >
                <ListItem class="-normal">多人数で押しかけること</ListItem>
                <ListItem class="-normal"
                  >大声をあげたり乱暴な言葉を使うこと</ListItem
                >
              </ListGroup>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv010/avatar-b.gif"
          >よかった。ドラマみたいな厳しい取り立てを受けることはないんだね…笑</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >そう、利用者が安心して利用できるように法律で定められているから、安心してローンを利用できるのよ</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60">返済手段が選べる！</HeadingTwo>

      <TalkGroup src="sv010/img01.jpg" class="_mb-md-60 _mb-sm-40">
        <TalkBox src="sv010/avatar-b.gif"
          >ローンの返済手段は、自分で選べるの？</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >返済手段は、金融機関からの口座引落しや、口座への振込み、コンビニATMなど、利用するサービスによって色々と選べるよ。今ではパソコン、スマートフォンで手続きできるサービスも増えてきてるよ</TalkBox
        >
      </TalkGroup>

      <ContentsCard class="-green _mb-sm-30">
        <div class="card-header">
          <IconBox src="light-green" class="-md _mb-sm-10"></IconBox>
          <h3 class="heading -green">
            au PAY スマートローンなら、返済手段が３通りから選べる
          </h3>
        </div>
        <div class="card-body02">
          <div class="card-groups">
            <div class="card-box">
              <ul>
                <li><span class="circle -green _mt-md-3">1</span></li>
                <li class="txt01 _mb-sm-15 _mb-md-20 _pl-sm-30">
                  お客さま金融機関口座から毎月決まった日に引き落とし
                </li>
                <li><span class="circle -green _mt-md-3">2</span></li>
                <li class="txt01 _mb-sm-15 _pl-sm-30">
                  指定の金融機関口座への振込みで返済
                </li>
              </ul>
            </div>
            <div class="card-box">
              <ul>
                <li><span class="circle -green _mt-md-3">3</span></li>
                <li class="txt01 _mb-sm-15 _mb-md-20 _pl-sm-30">
                  全国のセブン銀行ATMから、カードレスで返済
                </li>
              </ul>
            </div>
          </div>
        </div>
      </ContentsCard>

      <TalkGroup class="_mb-60">
        <TalkBox src="sv010/avatar-b.gif"
          >それは便利だね！自分の生活スタイルに合わせて返済手段を選べるのは安心だよ</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >それに、返済時の支払い回数は借り入れ金額によってあらかじめ決まっているけど、お金に余裕がある月に追加で返済することもできるのよ</TalkBox
        >
        <TalkBox src="sv010/avatar-b.gif"
          >ボーナスをもらった月やお金に余裕がある月は、多めに返済できるってことか！じゃあ、結果的に返済期間が短くなるし、利息が少なくて済むね</TalkBox
        >
      </TalkGroup>

      <HeadingTwo class="_mt-md-110 _mt-sm-60"
        >返済が遅れると遅延損害金というペナルティも…</HeadingTwo
      >

      <TalkGroup src="sv010/img02.jpg">
        <TalkBox src="sv010/avatar-a.gif"
          >返済計画を意識するのはとっても大切だから、一度シミュレーションしてみるといいわ</TalkBox
        >
        <TalkBox src="sv010/avatar-b.gif">どうして？</TalkBox>
        <TalkBox src="sv010/avatar-a.gif"
          >シミュレーションすると毎月の返済金額が分かるのよ。そうすれば、自分に合ったムリの無い返済計画かどうかが分かるでしょ？ローンの返済が遅れると『遅延損害金』が発生するから、計画的に返済することがとても大切なの</TalkBox
        >
      </TalkGroup>

      <TalkGroup class="_mb-30">
        <TalkBox src="sv010/avatar-b.gif"
          >そうなんだ。ところで、『遅延損害金』って何？</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >たとえば、レンタルDVDの返却を忘れると、延滞料金が発生するでしょ。それと同じように、キャッシング・ローンの支払いが遅れた場合も、延滞料金が発生するの。それが『遅延損害金』よ</TalkBox
        >
        <TalkBox src="sv010/avatar-b.gif"
          >なるほど…。お金を借りるときには、計画通りに返済することがとっても大切なんだね。ムリのない返済計画を立ててみるよ！</TalkBox
        >
        <TalkBox src="sv010/avatar-a.gif"
          >返済計画を立てるのに役立つシミュレーションもあるから、活用してみるといいわよ！</TalkBox
        >
      </TalkGroup>

      <ListGroup class="-note _mb-0">
        <ListItem class="-note"
          >au PAY
          スマートローンのご契約・ご利用には審査がございます。審査状況によりご希望に添えない場合がございますので、あらかじめご了承ください。</ListItem
        >
      </ListGroup>

      <div class="container">
        <BtngroupSingle class="-margin-lg">
          <BtnMain class="-normal -lg" router-name="sv002"
            >au PAY スマートローンの特徴について</BtnMain
          >
        </BtngroupSingle>
      </div>
      <CvBox class="-cv _mb-md-120 _mb-sm-60" />
    </div>

    <hr class="_mb-120 _mb-sm-60" />

    <div class="container">
      <HeadingTwo>おすすめ記事</HeadingTwo>

      <CardGroups class="-image-top-list">
        <CardBox router-name="sv011" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv011/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンって借りすぎないかな？</h3>
          </CardHeader>
          <CardBody
            >借り入れできる金額には制限があるんです！「いつのまにか借りすぎてしまうことってないかな…？」なんて方はこちら。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv012" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv012/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">お金を借りたいけど、周りの人に知られない？</h3>
          </CardHeader>
          <CardBody
            >「ローンのこと気になっていたけど、家族や恋人に知られないかな？」にお答えします。</CardBody
          >
        </CardBox>
        <CardBox router-name="sv009" class="-image-top">
          <CardHeader>
            <CardImage class="-green"
              ><img
                src="@/assets/images/sv/sv009/thumb.jpg"
                class="img-fluid"
                alt=""
            /></CardImage>
            <h3 class="heading">ローンにおける金利の仕組みとは？</h3>
          </CardHeader>
          <CardBody
            >「金利・利息・実質年率ってなんだろう？」いまさら聞けないローンのキホンについて！</CardBody
          >
        </CardBox>
      </CardGroups>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import ContentsHeader from "@/components/contents/ContentsHeader";
import ContentsIntro from "@/components/contents/ContentsIntro";
import HeadingTwo from "@/components/heading/HeadingTwo";
import TalkGroup from "@/components/contents/TalkGroup";
import TalkBox from "@/components/contents/TalkBox";
import ContentsCard from "@/components/contents/ContentsCard";
import IconBox from "@/components/icons/IconBox";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import CvBox from "@/components/box/CvBox";
import CardGroups from "@/components/card/CardGroups";
import CardBox from "@/components/card/CardBox";
import CardHeader from "@/components/card/CardHeader";
import CardImage from "@/components/card/CardImage";
import CardBody from "@/components/card/CardBody";
export default {
  name: "Sv010",
  components: {
    BreadcrumbGroup,
    CardBody,
    CardImage,
    CardHeader,
    CardBox,
    CardGroups,
    CvBox,
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    IconBox,
    ContentsCard,
    TalkBox,
    TalkGroup,
    HeadingTwo,
    ContentsIntro,
    ContentsHeader,
  },
  setup() {
    setMeta({
      title:
        "ローンの返済方法やルールとは？ ｜いまさら聞けない！ローンの基礎知識",
      description:
        "意外と知らないローンの基礎知識！返済方法や返済時のルールについて初心者でも分かりやすくご説明します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,返済方法",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "知っておきたい！ローンについて",
          routerName: "sv003",
        },
        {
          text: "いまさら聞けない！ローンの基礎知識",
          routerName: "sv043",
        },
        {
          text: "ローンの返済方法やルールとは？",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.contents-card {
  > .card-body01 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
        justify-content: space-between;
      }
      > .card-box {
        > .card-image {
          margin: 0 auto 20px;
          &.-width80 {
            max-width: 62%;
          }
          &.-width90 {
            max-width: 90%;
          }
        }
      }
    }
  }
}

.contents-card {
  > .card-body02 {
    background-color: #fff;
    border-radius: 10px;
    padding-top: 30px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 30px;
    @include mq-up(md) {
      padding-left: 50px !important;
      padding-right: 50px !important;
    }
    > .txt01 {
      text-align: center;
      margin-bottom: 0px;
    }
    > .card-groups {
      @include mq-up(md) {
        display: flex;
      }
      > .card-box {
        @include mq-up(md) {
          width: 50%;
        }
        .circle {
          width: 20px;
          height: 20px;
          color: #fff;
          border-radius: 50%;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          float: left;
          margin-right: 5px;
          @include mq-up(md) {
            margin-right: 10px;
          }
        }
        .-green {
          background-color: $green;
        }
        .txt01 {
          @include mq-up(md) {
            line-height: 26px;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
